const PARAM = 'reorder_properties';
const STORAGE_KEY = 'reorder_properties';

function base64UrlDecode(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '==='.slice((base64.length + 3) % 4);
  const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export default function restoreReorderPayloadFromUrl() {
  try {
    const raw = new URLSearchParams(window.location.search).get(PARAM);
    if (!raw) return false;

    const parsed = JSON.parse(base64UrlDecode(raw));
    if (!parsed || typeof parsed !== 'object') return false;

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
    return true;
  } catch (e) {
    return false;
  }
}
